export default __webpack_public_path__ + "static/Pattern-01-289613ca26600f34646849d5baf72efb.png";